import React from 'react';
import { AlertTriangle, Battery, Volume2, Clock } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function PainPoints() {
  return <section className="bg-gray-50 py-16 md:py-24" data-id="element-106">
      <div className="mx-auto max-w-4xl px-4" data-id="element-107">
        <h2 className="mb-12 text-center text-3xl font-bold text-gray-900 md:text-4xl" data-id="element-108">
          Si sos docente, esto te va a sonar muy familiar…
        </h2>

        <div className="mb-16 space-y-6 text-lg text-gray-700" data-id="element-109">
          <p data-id="element-110">Entrás al aula. Querés empezar la clase.</p>
          <p className="font-semibold" data-id="element-111">
            Pero hay ruido. Interrupciones. Alumnos desconectados. Conflictos
            que aparecen de la nada.
          </p>
          <p data-id="element-112">
            Probás hablar más fuerte. Probás explicar otra vez. Probás pedir
            silencio.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 mb-16" data-id="element-113">
          <div className="rounded-xl bg-white p-8 shadow-lg border-l-4 border-red-500" data-id="element-114">
            <h3 className="mb-4 text-xl font-bold text-gray-900 flex items-center gap-2" data-id="element-115">
              <Volume2 className="text-red-500" data-id="element-116" />Y mientras tanto, sentís que:
            </h3>
            <ul className="space-y-3" data-id="element-117">
              <li className="flex items-start gap-3" data-id="element-118">
                <span className="mt-1.5 h-2 w-2 rounded-full bg-red-500 shrink-0" data-id="element-119" />
                <span data-id="element-120">Improvisás todo el tiempo</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-121">
                <span className="mt-1.5 h-2 w-2 rounded-full bg-red-500 shrink-0" data-id="element-122" />
                <span data-id="element-123">El clima se te va de las manos</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-124">
                <span className="mt-1.5 h-2 w-2 rounded-full bg-red-500 shrink-0" data-id="element-125" />
                <span data-id="element-126">Terminás agotado</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-127">
                <span className="mt-1.5 h-2 w-2 rounded-full bg-red-500 shrink-0" data-id="element-128" />
                <span data-id="element-129">
                  Volvés a casa pensando qué podrías haber hecho distinto
                </span>
              </li>
            </ul>
          </div>

          <div className="rounded-xl bg-white p-8 shadow-lg border-l-4 border-orange-500" data-id="element-130">
            <h3 className="mb-4 text-xl font-bold text-gray-900 flex items-center gap-2" data-id="element-131">
              <Clock className="text-orange-500" data-id="element-132" />
              El ciclo del desgaste docente
            </h3>
            <p className="mb-4 text-gray-600" data-id="element-133">Cada día es parecido:</p>
            <div className="flex flex-col gap-2 text-sm font-medium text-gray-800" data-id="element-134">
              <div className="flex items-center gap-2" data-id="element-135">
                <div className="h-6 w-6 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center text-xs" data-id="element-136">
                  1
                </div>
                Llegás con ganas de dar clase
              </div>
              <div className="ml-3 h-4 border-l-2 border-dashed border-gray-300" data-id="element-137"></div>
              <div className="flex items-center gap-2" data-id="element-138">
                <div className="h-6 w-6 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center text-xs" data-id="element-139">
                  2
                </div>
                Algo se desordena
              </div>
              <div className="ml-3 h-4 border-l-2 border-dashed border-gray-300" data-id="element-140"></div>
              <div className="flex items-center gap-2" data-id="element-141">
                <div className="h-6 w-6 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center text-xs" data-id="element-142">
                  3
                </div>
                Intervenís como podés
              </div>
              <div className="ml-3 h-4 border-l-2 border-dashed border-gray-300" data-id="element-143"></div>
              <div className="flex items-center gap-2" data-id="element-144">
                <div className="h-6 w-6 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center text-xs" data-id="element-145">
                  4
                </div>
                Te desgastás
              </div>
              <div className="ml-3 h-4 border-l-2 border-dashed border-gray-300" data-id="element-146"></div>
              <div className="flex items-center gap-2" data-id="element-147">
                <div className="h-6 w-6 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center text-xs" data-id="element-148">
                  5
                </div>
                Y mañana volvés a empezar
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16 text-center" data-id="element-149">
        <CTAButton className="text-lg" data-id="element-150">QUIERO DEJAR DE IMPROVISAR</CTAButton>
      </div>
    </section>;
}